// extracted by mini-css-extract-plugin
module.exports = {"FullWidth":"full-width_FullWidth__Dh46g","Article":"full-width_Article__1nylr","image":"full-width_image___XoOO"};